import { IAddSection } from '@sdk/contracts';
import { Button, Form, Input, Modal } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Icon } from '@/components/Icon';
import { RULES } from '@/constants';
import { useCourseDetail } from '@/store';
import { useMutateCourses } from '@/store/courses/useMutateCourses';

export const AddComplementaryMaterialSection = () => {
  const [form] = Form.useForm();
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation(['CourseTranslations', 'DefaultTranslations']);
  const { addComplementaryMaterialSection } = useMutateCourses();
  const { course } = useCourseDetail();

  if (!course) return null;

  const handleCancel = () => {
    setIsOpen(false);
    form.resetFields();
  };

  const handleFinish = (values: IAddSection) => {
    addComplementaryMaterialSection({ course, section: values }, { onSuccess: handleCancel });
  };

  return (
    <>
      <Button onClick={() => setIsOpen(true)} icon={<Icon i="AddAlt" />}>
        {t('CourseTranslations:ADD_SECTION')}
      </Button>
      <Modal
        open={isOpen}
        onOk={form.submit}
        onCancel={handleCancel}
        title={t('CourseTranslations:NEW_SECTION')}
        cancelText={t('DefaultTranslations:CANCEL')}
        okText={t('CourseTranslations:ADD_SECTION')}>
        <Form form={form} onFinish={handleFinish}>
          <Form.Item name="name" rules={[RULES.REQUIRED]}>
            <Input placeholder={t('CourseTranslations:SECTION_NAME_PLACEHOLDER')} />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
